import React from "react";

function UnAnswerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 32 32"
    >
      <g fill="#fffbfb">
        <path
          d="M23.99 15.35V7.12a2.1 2.1 0 00-2.1-2.1H6.11a2.1 2.1 0 00-2.1 2.1v12.79c0 1.15.94 2.09 2.1 2.1H7.6l1.6 2.28a.997.997 0 001.63.01l1.64-2.29h3.62A5.999 5.999 0 0022 26.99 6 6 0 0027.99 21c0-2.61-1.67-4.84-4-5.65zm-12.04 4.66c-.32 0-.63.16-.81.42l-1.11 1.56-1.09-1.56c-.19-.26-.5-.42-.82-.42H6.11a.1.1 0 01-.1-.1V7.12c0-.06.04-.1.1-.1h15.78c.06 0 .1.04.1.1V15c-2.97 0-5.43 2.17-5.9 5.01zM22 24.99c-2.21 0-3.99-1.78-4-3.98V21c0-2.21 1.79-4 4-4a3.995 3.995 0 010 7.99z"
          data-original="#000000"
        ></path>
        <path
          d="M18.999 11.017H9.04a1 1 0 110-2h9.959a1 1 0 110 2zm-9.968 3.011a1 1 0 010-2l9.967-.006h.001a1 1 0 01.001 2l-9.968.006zm0 3a1 1 0 010-2l5.967-.006h.001a1 1 0 01.001 2l-5.968.006zM23.95 21.53c.39.4.39 1.03 0 1.42a1.001 1.001 0 01-1.41 0l-.54-.54-.55.55a1.001 1.001 0 01-1.41 0c-.39-.39-.39-1.02 0-1.42l.55-.54-.55-.55c-.39-.39-.39-1.02 0-1.42a.996.996 0 011.41 0l.55.55.54-.54a.996.996 0 011.41 0c.39.4.39 1.03 0 1.42l-.53.54z"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default UnAnswerIcon;